import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import type { ScopeVerdict } from "@/lib/org-structure-tree";

// "Awaiting approval", não "Pending": ao lado do selo de execução, dois
// "Pending" diferentes na mesma tela não diziam qual era qual.
const VERDICT_LABEL: Record<ScopeVerdict, string> = {
  pending: "Awaiting approval",
  approved: "Approved",
  out_of_scope: "Out of scope",
};

// Tons próprios, distintos da paleta de `OrgUnitStatusBadge`: os dois selos
// aparecem lado a lado na unidade já cadastrada, e escopo (decisão do
// consultor) não pode se confundir com execução (o que o agente fez).
const VERDICT_CLASS: Record<ScopeVerdict, string> = {
  pending: "bg-[#fdf6e3] text-[#9a6b00]",
  approved: "bg-[#e8eef7] text-[#08254c]",
  out_of_scope: "bg-[#f1f3f6] text-[#7b8799]",
};

/** Selo do veredito de escopo da unidade — mesmo formato de
 * `OrgUnitStatusBadge`, para os dois lerem como um par. */
export function OrgUnitScopeBadge({ verdict }: { verdict: ScopeVerdict }) {
  const { t } = useTranslation();

  return (
    <Badge
      data-testid="org-unit-scope-badge"
      variant="outline"
      className={`border-transparent font-mono text-[10px] uppercase tracking-[0.06em] ${VERDICT_CLASS[verdict]}`}
    >
      {t(VERDICT_LABEL[verdict])}
    </Badge>
  );
}
